import React from "react";
import { Image } from "antd";

const HeadingRow = ({ heading, imageUrl }) => {
  return (
    <div className="mt-4 mb-4">
      <span>
        <Image width={80} src={imageUrl} />
      </span>
      <span
        style={{
          display: "inline-flex",
          verticalAlign: "middle",
          marginLeft: "15px",
        }}
      >
        <h3 style={{ marginBottom: "0px" }}>{heading}</h3>
      </span>
    </div>
  );
};

export default HeadingRow;
